import { Observable } from "rxjs";

export const firstValueFrom = (value: any) => {
    if (value instanceof Observable) {
        return value.toPromise();
    } else if (value instanceof Promise) {
        return value;
    } else {
        throw new Error('REQUEST_NOT_EXIST');
    }
};

//UTILITY
export const deepFind = (obj, path) => {
    var paths = path.split('.'), current = obj, i;
    for (i = 0; i < paths.length; ++i) {
        if (current[paths[i]] == undefined) {
            return undefined;
        } else {
            current = current[paths[i]];
        }
    }
    return current;
};

export const cleanObj = (obj) => {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj
};